import PAPI from "./partnerInstance";
import { userAccessToken } from "../helpers";


export const fetchScanList = async (
  ) => {
    try {
      console.log("return from scan list");
      return;
      const response = await PAPI.get(
        `/get-scan-list`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
  
      return response;
    } catch (error) {}
  };


  export const fetchMedmoOrderList = async (filter) => {
    const {
      location_id,
      page,
      per_page,
      search_term,
      order_by,
      status,
    } = filter;
 
    try {
      let searchParam = search_term ? `&search_term=${search_term}` : "";
      let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
      let sStatus = status ? `&status=${status}` : "";

      const response = await PAPI.get(
        `/get-medmo-order-list?location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}${sStatus}`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
  
      return response;
    } catch (error) {}
  };

  

export const fetchSingleOrder = async (
  order_id
) => {
  try {
    const response = await PAPI.get(
      `/get-memdo-order/single?order_id=${order_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};


export const createOrderComment = async (
  account_id,
  comment,
  medmo_order_id,
  file
) => {
  try {

    const formData = new FormData();

    formData.append('account_id', account_id);
    formData.append('comment', comment || '');
    formData.append('medmo_order_id', medmo_order_id);

    if (file) {
      formData.append('file', file);
    }

    const response = await PAPI.post(
      "/create-order-comment", formData, 
     
      {
        headers: {
          "Accept": "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};



export const getOrderComment = async (
  account_id,
  medmo_order_id
) => {
  try {
    const response = await PAPI.get(
    `/get-order-comment?account_id=${account_id}&medmo_order_id=${medmo_order_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};



export const getOrderFiles = async (
  account_id,
  medmo_order_id
) => {
  try {
    const response = await PAPI.get(
    `/get-order-files?account_id=${account_id}&medmo_order_id=${medmo_order_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};


export const createOrder = async (patient_id, prescriber_id, location_id, formDataObj) => {
  try {
    const response = await PAPI.post(
      `/create-order/${patient_id}/${prescriber_id}/${location_id}`,
      formDataObj,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};